var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.77557 6.59057C3.74211 2.68406 7.78153 0 12.4588 0C15.6876 0 18.385 1.1826 20.4578 3.10928L17.0828 6.40461C16.2191 5.59402 14.7043 4.62403 12.4588 4.62403C9.29637 4.62403 6.61231 6.7102 5.64223 9.59359C5.40305 10.3377 5.25695 11.1349 5.25695 11.9588C5.25695 12.7826 5.40305 13.5799 5.65551 14.324C6.61231 17.2074 9.29637 19.2934 12.4588 19.2934C14.2393 19.2934 15.5946 18.8018 16.6045 18.0976C18.199 16.9815 18.9165 15.3205 19.0493 14.2176H12.4588V9.77963H23.6867C23.8594 10.5237 23.9392 11.2413 23.9392 12.2245C23.9392 15.8653 22.637 18.9347 20.3781 21.0209C18.3982 22.8545 15.6876 23.9176 12.4588 23.9176C7.78153 23.9176 3.74211 21.2334 1.77557 17.3269C0.965069 15.7058 0.5 13.8855 0.5 11.9588C0.5 10.0321 0.965069 8.21166 1.77557 6.59057Z",
    fill: "#232632"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.fd4b5cad340aa5018785947be3f39a2a.svg";
export { ForwardRef as ReactComponent };